import $http from '@/libs/axios'

export default class RefundsAPI {
  static async list(params: any) {
    return (await $http.get('/refunds/list', { params })).data
  }

  static async refundOrder(payload: any) {
    return (await $http.post('/orders/make-refund', payload)).data
  }

  static async verifyRefund(refundId: string | number) {
    return (await $http.post(`/refunds/verify/${refundId}`)).data
  }

  static async getSettings(branchId: number) {
    return (await $http.get(`/refunds/settings/${branchId}`)).data
  }
}
